/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import toastr from 'toastr';
// eslint-disable-next-line import/no-unresolved
import Cookies from 'js-cookie';
import axios from '../setup/axios';
import config from '../setup/config';
import router from '../setup/router';

export default {
  async initialise({ commit, dispatch, getters }) {
    commit('loadFromStorage');
    if (router.currentRoute.path.startsWith('/Login')) return;
    await dispatch('getUserInfo');
  },
  async getUserInfo({ commit, dispatch, getters }) {
    if (!getters.isClient) return true;

    try {
      const response = await axios.get(`${config.microservices.client}/getuserinfo`);
      if (!response.data.success) { throw new Error('Result was not success'); }
      commit('setUserInfo', response.data.data.userInfo);
      commit('setClientInfo', response.data.data.clientInfo);
      dispatch('setupAptrinsic');
      return true;
    } catch {
      if (!router.currentRoute.path.startsWith('/Login')) {
        router.push('/Login');
      }
      return false;
    }
  },
  notify(_context, { title, message }) {
    switch (title) {
    case 'Success': toastr.success(message, title); break;
    case 'Error': toastr.error(message, title); break;
    case 'Warning': toastr.warning(message, title); break;
    default: toastr.info(message, title);
    }
  },
  toggleTheme({ commit, getters }) {
    const theme = getters.theme === 'light-theme' ? 'dark-theme' : 'light-theme';
    commit('setTheme', theme);
    document.documentElement.className = theme;
  },
  toggleSidenav({ commit, getters }) {
    commit('setSidenavCollapsed', !getters.sidenavCollapsed);
  },
  async login({ dispatch }, { username, password }) {
    const unauthorised = 401;
    const forbidden = 403;

    try {
      const response = await axios.post(`${config.microservices.identity}/login`, { username, password });
      const {
        mfa,
        userData = '',
        csrfToken = '',
      } = response.data;

      if (!mfa || !mfa.enabled) {
        localStorage.setItem('userData', userData); // already a stringified json
        localStorage.setItem('csrfToken', String(csrfToken));
      }

      const isMfaEnabled = mfa?.enabled;
      const sessionId = mfa?.sessionId;

      if (isMfaEnabled) return { success: true, isMfaEnabled, sessionId };

      const success = await dispatch('setTokensAndUserInfo');

      return { success };
    } catch (err) {
      const res = { success: false, errType: 'UNKNOWN' };

      if (!err.response) {
        res.errType = 'COMM_ERROR';
        return res;
      }

      switch (err.response.status) {
      case unauthorised:
        res.errType = 'UNAUTHORISED';
        break;
      case forbidden:
        res.errType = 'FORBIDDEN';
        break;
      default:
        break;
      }

      return res;
    }
  },
  async setTokensAndUserInfo({ commit, dispatch, getters }) {
    commit('setUserData', JSON.parse(localStorage.getItem('userData')));
    const success = await dispatch('getUserInfo');
    return success;
  },
  async authenticateWithOtp({ dispatch }, { otp, sessionId }) {
    try {
      const response = await axios.post(`${config.microservices.identity}/login/mfaauthentication`, { otp, sessionId });

      const {
        userData = '',
        csrfToken = '',
      } = response.data;

      localStorage.setItem('userData', userData); // already a stringified json
      localStorage.setItem('csrfToken', String(csrfToken));

      await dispatch('setTokensAndUserInfo');
    } catch (e) {
      if (e?.response?.status === 401) throw new Error('INVALID_OTP');
      else throw new Error('DEFAULT');
    }
  },
  async impersonate({ commit, dispatch, getters }, { clientId }) {
    try {
      const response = await axios.post(`${config.microservices.identity}/login/impersonate`, { clientId });
      const {
        userData = '',
        csrfToken = '',
      } = response.data;
      localStorage.setItem('userData', userData); // already a stringified json
      localStorage.setItem('csrfToken', String(csrfToken));
      commit('setUserData', JSON.parse(userData));
      if (this.hasModule('reportingui')) dispatch('reportingui/clearCampaigns');

      const userInfo = await dispatch('getUserInfo');
      return userInfo;
    } catch (err) {
      return false;
    }
  },
  async logout({ commit, dispatch }, { includeReturnUrl } = {}) {
    localStorage.clear();

    dispatch('resetAptrinsic');
    const path = includeReturnUrl && !router.currentRoute.path.startsWith('/Login')
      ? `/Login?ReturnUrl=${encodeURIComponent(router.currentRoute.path)}`
      : '/Login';

    // Changing the href rather than using the router because we want to ensure anything
    // vue related that's been cached in the previous vue session is removed.
    window.location.href = path;
  },
  async resetPassword(_context, request) {
    try {
      const response = await axios.post(`${config.microservices.identity}/Account/ResetPassword`, request, { excludeToken: true });
      return response.data;
    } catch {
      return false;
    }
  },
  async setupAptrinsic({ getters }) {
    if (!getters.isImpersonator) {
      window.aptrinsic('identify', {
        id: getters.userInfo.userId,
        firstName: getters.userInfo.firstName,
        lastName: getters.userInfo.lastName,
      }, {
        id: getters.clientInfo.clientId,
        name: getters.clientInfo.name,
      });
    }
  },
  async resetAptrinsic() {
    window.aptrinsic('reset');
    document.cookie = 'apt.uid=; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'apt.sid=; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  },
  async requestPasswordReset(_getters, userName) {
    await axios.post(`${config.microservices.identity}/Account/ForgotPassword`, { UserName: userName });
  },
  async updateShowUserTutorial({ commit }, show) {
    commit('setShowTutorial', show);
  },
  async updateClientUserShowTutorial({ getters }, showTutorial) {
    const clientUserId = getters.userInfo.userId;

    if (clientUserId) {
      await axios.post(`${config.microservices.client}/updatetutorialflag`, {
        showTutorial,
        clientUserId,
      });
    } else {
      throw new Error('No UserId given. Could not update tutorial flag.');
    }
  },
};
